import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Stack,
  InputAdornment,
  Radio,
  Popper,
  Paper,
  ClickAwayListener,
} from "@mui/material";
import { BsSearch } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { IoIosArrowDropdown } from "react-icons/io";
import { Chip } from "@mui/material";
import { IoFilter } from "react-icons/io5";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";

const SelectFieldSectionMobile = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState("");
  const [hoveredCard, setHoveredCard] = useState(null); // State for tracking hovered card
  const [selectedOptions, setSelectedOptions] = useState({
    Message: {},
    Category: {},
    SubCategory: {},
    Price: {},
  });
  const [cards, setCards] = useState([]); // State to store templates fetched from API
  const [loading, setLoading] = useState(true); // State for loading status
  let [selectedCategory, setSelectedCategory] = useState("");
  let [selectedSubCategory, setSelectedSubCategory] = useState("");
  let [selectedPrice, setSelectedPrice] = useState("");
  const [selectedMessageType, setSelectedMessageType] = useState("");
  const [searchQuery, setSearchQuery] = useState(""); // To store the search input
  const [visibleCards, setVisibleCards] = useState(8);
  const [chips, setChips] = useState([]); // State for chips
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const gridContainerRef = useRef(null);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [nestedAnchorEl, setNestedAnchorEl] = useState(null);
  const [nestedMenuType, setNestedMenuType] = useState("");

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };
  const handleFilterButtonClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
    setIsFilterOpen((prev) => !prev); // toggle on click
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleWheelScroll = (event) => {
    const container = gridContainerRef.current;

    if (container) {
      const isScrollable = container.scrollHeight > container.clientHeight;

      if (isScrollable) {
        event.preventDefault(); // Stop parent scroll
        container.scrollTop += event.deltaY;
      }
    }
  };
  const navigate = useNavigate();

  // List of options for menus
  let menuOptions = {
    Message: ["Template", "Interactive"],
    Category: ["Authentication", "Marketing", "Utility"],

    SubCategory: subCategoryOptions,
    Price: ["Free", "Paid"],
  };

  const allSubCategoryOptions = {
    authentication: ["Authentication"],
    marketing: [
      "Catalog",
      "Carousel",
      "LTO",
      "Coupon",
      "Media card carousel",
      "MPM",
      "Product Card Carousel",
      "SPM",
      "Festival",
    ],
    utility: ["Reminder", "Notification", "Alert"],
  };

  const handleMenuOpen = (event, menuType) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuType);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu("");
  };

  const handleCheckboxChange = (menuType, option) => {
    const value = option === "All" ? "" : option.toLowerCase();
    const updatedSelectedOptions = {
      ...selectedOptions,
      [menuType]: { [option]: true },
    };

    setSelectedOptions(updatedSelectedOptions);

    const chipExists = chips.find((chip) => chip.type === menuType);
    if (chipExists) {
      setChips((prev) =>
        prev.map((chip) =>
          chip.type === menuType ? { ...chip, label: option } : chip
        )
      );
    } else {
      setChips((prev) => [...prev, { type: menuType, label: option }]);
    }

    handleMenuClose();

    switch (menuType) {
      case "Message":
        setSelectedMessageType(value);
        break;
      case "Category":
        setSelectedCategory(value);
        setSubCategoryOptions(allSubCategoryOptions[value] || []); // Update Dynamic List
        break;
      case "SubCategory":
        setSelectedSubCategory(value);
        break;
      case "Price":
        setSelectedPrice(value);
        break;
      default:
        break;
    }
  };

  const handleChipDelete = (chipType) => {
    //console.log(chipType);
    switch (chipType) {
      case "Message":
        setSelectedMessageType("");
        break;
      case "Category":
        setSelectedCategory("");
        break;
      case "SubCategory":
        setSelectedSubCategory("");
        break;
      case "Price":
        setSelectedPrice("");
        break;
      default:
        break;
    }
    setChips((prev) => prev.filter((chip) => chip.type !== chipType));
    setSelectedOptions((prev) => ({ ...prev, [chipType]: "" }));
    //fetchTemplates();
  };

  const handleClearAll = (menuType) => {
    setSelectedOptions((prev) => ({ ...prev, [menuType]: {} }));
    switch (menuType) {
      case "Message":
        setSelectedMessageType("");
        break;
      case "Category":
        setSelectedCategory("");
        break;
      case "SubCategory":
        setSelectedSubCategory("");
        break;
      case "Price":
        setSelectedPrice("");
        break;
      default:
        break;
    }
  };

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase()); // Update search query as the user types
  };

  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        // `http://192.168.29.63:5000/api/category_templates?category=${selectedCategory}&subcategory=${selectedSubCategory}&price=${selectedPrice}&messagetype=${selectedMessageType}&inputsearch=${searchQuery}`
        `http://localhost:5000/api/category_templates?category=${selectedCategory}&subcategory=${selectedSubCategory}&price=${selectedPrice}&messagetype=${selectedMessageType}&inputsearch=${searchQuery}`
      );
      if (response.ok) {
        const data = await response.json();
        setCards(data);
      } else {
        console.error("Failed to fetch templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [
    selectedCategory,
    selectedMessageType,
    selectedSubCategory,
    selectedPrice,
    searchQuery,
  ]);

  const handleCardClick = (card, index) => {
    navigate("/template-details", { state: { card, index } });
  };

  const handleShowMore = () => {
    setVisibleCards(cards.length); // Make all remaining cards visible
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Stack sx={{ width: "100%" }}>
        <ClickAwayListener
          // onClickAway={() => setIsFilterOpen(false)}
          onClickAway={() => {
            setIsFilterOpen(false);
            setNestedMenuType("");
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xl: "row",
                lg: "row",
                md: "row",
                sm: "row",
                xs: "row",
              },
              flexWrap: "wrap",
              gap: "15px",
              justifyContent: "space-between",
              // border: "1px solid red",
              mb: 3,
              //   mt: 1,
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Search Templates..."
              size="small"
              sx={{
                // flex: "1",
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white", // removes the border color on hover
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white", // removes the border color when focused
                  },
                },
                backgroundColor: "white",
                width: {
                  xl: "30%",
                  lg: "30%",
                  md: "30%",
                  sm: "25%",
                  xs: "62%",
                },
                // backgroundColor: "#054e92",
                color: "white",
                // border: "1px solid red",
                borderRadius: "8px",
              }}
              value={searchQuery}
              onChange={handleInputChange} // Trigger on input change
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BsSearch />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="outlined"
              startIcon={<IoFilter style={{ color: "black" }} />} // icon bhi black ho jaye white background pe
              onClick={handleFilterButtonClick}
              sx={{
                color: "black", // text color
                backgroundColor: "white", // background white
                border: "1px solid white", // border white
                "&:hover": {
                  backgroundColor: "#f0f0f0", // subtle hover effect
                  border: "1px solid white",
                },
                borderRadius: "8px",
              }}
            >
              Filter
            </Button>

            <Dialog
              open={isFilterOpen}
              onClose={() => {
                setIsFilterOpen(false);
                setNestedMenuType("");
              }}
              fullWidth
              // maxWidth="sm"
              PaperProps={{
                sx: { borderRadius: "12px", p: 2, backgroundColor: "white" },
              }}
            >
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 2,
                  // border: "1px solid red",
                }}
              >
                Filters
                <IconButton
                  onClick={() => {
                    setIsFilterOpen(false);
                    setNestedMenuType("");
                  }}
                >
                  <AiOutlineClose size={20} />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                {Object.keys(menuOptions).map((menuType) => (
                  <Box key={menuType} sx={{ mb: 2 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                        setNestedAnchorEl(e.currentTarget);
                        setNestedMenuType((prev) =>
                          prev === menuType ? "" : menuType
                        );
                      }}
                      sx={{
                        m: 0.5,
                        textTransform: "none",
                        fontSize: "13px",
                        width: "150px",
                        justifyContent: "space-between",
                      }}
                      endIcon={<IoIosArrowDropdown />}
                    >
                      {menuType}
                    </Button>

                    {nestedMenuType === menuType && (
                      <Box sx={{ mt: 1, pl: 1 }}>
                        <Paper sx={{ p: 1 }}>
                          <FormGroup>
                            {menuOptions[menuType].map((option) => (
                              <MenuItem key={option} sx={{ py: 0 }}>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={
                                        selectedOptions[menuType][option] ||
                                        false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(menuType, option)
                                      }
                                    />
                                  }
                                  label={
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {option}
                                    </Typography>
                                  }
                                />
                              </MenuItem>
                            ))}
                          </FormGroup>
                        </Paper>
                      </Box>
                    )}
                  </Box>
                ))}
              </DialogContent>
            </Dialog>
          </Box>
        </ClickAwayListener>
      </Stack>
      <Box sx={{ padding: "20px", width: { xl: "76%", lg: "95%", md: "98%" } }}>
        {/* Top Section: Search Bar and Select Menus */}

        {/* Chips Section */}

        {/* <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          {chips.map((chip) => (
            <Chip
              key={chip.type}
              label={`${chip.type}: ${chip.label}`}
              onDelete={() => handleChipDelete(chip.type)}
              sx={{
                backgroundColor: "white", // chip background white
                color: "black", // text color black
                border: "1px solid white", // white border
                "& .MuiChip-deleteIcon": {
                  color: "black", // delete icon color black
                },
              }}
            />
          ))}
        </Stack> */}

        {/* Cards Grid Section */}
        {/* Cards Grid Section */}
        <Box
          ref={gridContainerRef}
          onWheel={handleWheelScroll}
          sx={{
            position: "relative",
            // maxHeight: "1110px",
            // overflowY: "auto",
            height: "auto",
            // border: "1px solid red",
          }}
        >
          {cards.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                color: "#666",
               
                fontWeight: "bold",
                // paddingTop: "100px",
                // border: "1px solid red",
              }}
            >
              <Typography sx={{ fontSize: { xl: "48px", lg: "48px", sm: "38px", xs: "28px" },}}>No Data Found</Typography>
            </Box>
          ) : (
            <Grid container spacing={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}>
              {cards.slice(0, visibleCards).map((card, index) => (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  key={index}
                  // onMouseEnter={() => setHoveredCard(index)}
                  // onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    // justifyContent: "center",
                    // alignItems: "center",
                    // border: "1px solid red",
                  }}
                >
                  <Card
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                      borderRadius: "16px",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      backdropFilter: "blur(8px)",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                      // border: "3px solid blue",
                      width: { xl: "100%" },
                    }}
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => handleCardClick(card, index)} // Navigate on card click
                  >
                    {/* Modified 3D Badge */}
                    <Stack
                      sx={{
                        height: "150px",
                        width: "150px",
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        // border: "2px solid red",
                        overflow: "hidden",
                        filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.25))",
                      }}
                    >
                      <Stack
                        sx={{
                          display: "block",
                          background: "#f00",
                          color: "#fff",
                          width: "100%",
                          height: "32px",
                          lineHeight: "32px",
                          textAlign: "center",
                          textTransform: "uppercase",
                          fontWeight: 600,
                          fontSize: "0.85rem",
                          transformOrigin: "top right",
                          transform: "rotate(45deg) translate(50%, 100%)",
                          "&::before, &::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "-10px",
                            border: "5px solid transparent",
                            filter: "brightness(0.8)",
                          },
                          "&::before": {
                            left: "10px",
                            borderTopColor: "#f00",
                          },
                          "&::after": {
                            right: "10px",
                            borderTopColor: "#f00",
                          },
                        }}
                      >
                        POPULAR
                      </Stack>
                    </Stack>
                    <CardMedia
                      component="img"
                      sx={{
                        height: {
                          xl: "440px",
                          lg: "440px",
                          sm: "440px",
                          xs: "320px",
                        },
                        // objectFit: "contain",
                        borderRadius: "16px 16px 0 0", // Rounded top corners
                        // border: "2px solid green",
                      }}
                      // image={`http://192.168.29.63:5000/images/${card.image}`}
                      image={`http://localhost:5000/images/${card.image}`}
                      alt={card.title}
                    />
                    {/* Glassmorphic Dialog Box */}
                    {/* <Box
                      sx={{
                        position: "absolute",
                        top: hoveredCard === index ? "0" : "-100%",
                        left: 0,
                        width: "100%",
                        height: "50%",
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(12px)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        borderRadius: "12px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        zIndex: 1,
                        transition: "top 0.3s ease-in-out",
                        padding: "20px",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          marginBottom: "8px",
                          fontWeight: 600,
                          fontSize: { xs: "12px", sm: "16px" },
                        }}
                      >
                        {card.title}
                      </Typography>
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#6B46C1",
                          borderColor: "#6B46C1",
                          textTransform: "none",
                          marginBottom: "10px",
                        }}
                      >
                        Preview
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#6B46C1",
                          color: "#FFF",
                          textTransform: "none",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        Use this template
                      </Button>
                    </Box> */}
                    
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
          {/* Show More Button with blurred background */}
          {cards.length > visibleCards && (
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "250px", // Height for the blur effect
                backdropFilter: "blur(8px)",
                backgroundColor: "rgba(255, 255, 255, 0.3)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <Button
                onClick={handleShowMore}
                variant="contained"
                sx={{
                  backgroundColor: "#6B46C1",
                  color: "#FFF",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                }}
                size="large"
              >
                Show More
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Stack>
  );
};

export default SelectFieldSectionMobile;
